import { Space, Dropdown } from 'antd';
import { useContext, useEffect, useState } from 'react';
import { AiOutlineDown } from 'react-icons/ai';
import { ShieldContext } from '../context/shieldContext';
import Responsables from './Responsables';

const AssignedResponsable = () => {
    const [responsableId, setResponsableId] = useState<string>();
    const [active, setActive] = useState<boolean>(false);

    const { issue } = useContext(ShieldContext);

    const handleActive = () => setActive(!active);

    const onChangeResponsable = (responsableId: string) => {
        setResponsableId(responsableId);
    };

    useEffect(() => {
        if (issue?.responsableID) {
            setResponsableId(issue?.responsableID);
        }
    }, []);

    return (
        <Dropdown
            trigger={['click']}
            placement="bottomRight"
            visible={active}
            overlay={(
                <Responsables
                    handleActive={handleActive}
                    responsableId={responsableId}
                    onChangeResponsable={onChangeResponsable}
                />
            )}
        >
            <Space
                direction="horizontal"
                size={16}
                style={{
                    width: '100%',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    border: '0.5px solid #d9d9d9',
                    borderRadius: 4,
                    padding: '4px 8px',
                }}
                onClick={handleActive}
            >
                <span>
                    {
                        responsableId ? issue?.responsableName : 'Unassigned'
                    }
                </span>
                <AiOutlineDown
                    size={16}
                    style={{ cursor: 'pointer', verticalAlign: 'middle' }}
                />
            </Space>
        </Dropdown>
    );
};

export default AssignedResponsable;
